import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import * as Routes from '@/modules/routes';

export interface RepairEntry {
  action: 'repoint' | 'unassign' | 'bulk_unassign' | 'redrive';
  actor: string | null;
  assignment_id: number;
  assignment_title: string | null;
  batch_id: string | null;
  created_at: string;
  id: number;
  summary: string | null;
  undoable: boolean;
  undone_at: string | null;
  undone_by: string | null;
}

// Every query a repair or its undo can change. Prefix keys, so they cover every teacher and assignment.
export const REPAIRED_QUERIES = [
  'gradeSyncRepairs', 'gradeSyncAssignments', 'gradeSyncAssignment', 'gradeSyncCourseMatch',
  'gradeSyncMisclaims', 'gradeSyncAssignees', 'gradeSyncVerify',
];

const useRepairHistory = (stafferId: string) => {
  const queryClient = useQueryClient();

  const history = useQuery({
    enabled: stafferId.trim().length > 0,
    queryFn: async (): Promise<RepairEntry[]> => {
      const { data } = await axios.get(Routes.plato_api_sysadmin_grade_sync_repairs_path(stafferId));

      return data.data;
    },
    queryKey: ['gradeSyncRepairs', stafferId],
  });

  const undo = useMutation({
    mutationFn: async (id: number) => axios.post(Routes.plato_api_sysadmin_grade_sync_undo_repair_path(id)),
    onSuccess: () => REPAIRED_QUERIES.forEach(key => queryClient.invalidateQueries({ queryKey: [key] })),
  });

  return { history, undo };
};

export default useRepairHistory;
